import script from "./ScreenCenterTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreenCenterTop.vue?vue&type=script&lang=ts&setup=true"

import "./ScreenCenterTop.vue?vue&type=style&index=0&id=63bdabd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63bdabd8"]])

export default __exports__